import React from "react";
import "./LoadingContainer.css";

interface LoadingContainerProps {
  loading: boolean;
  children?: React.ReactNode;
}

const LoadingContainer: React.FC<LoadingContainerProps> = ({ loading, children }) => {
  if (!loading) return <>{children}</>;
  return (
    <span className="loading-background load-position">
      <span className="loading-indicator">
        <span style={{ position: "relative", background: "none", width: 200, height: 200, display: "block" }}>
          Loading...
        </span>
      </span>
    </span>
  );
};

export default LoadingContainer;
